import { BaseDataService } from './BaseDataService';
import { SecondaryReport, SurveyVersion, SecondaryReportOrgUser } from '../../models';
import { NotificationService } from '../../services';

export class SecondaryReportDataService extends BaseDataService<SecondaryReport> {
    constructor(notificationService: NotificationService) {
        super('SecondaryReport', 'SecondaryReports', notificationService);
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic groups.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
    
    public getAllForUser(userId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/forUser/${userId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving secondary reports for user.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
    
    public getAllForOrg(orgId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/forOrg/${orgId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving secondary reports for org.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public createOrgUser(entity: SecondaryReportOrgUser): Promise<any> {

        const endpoint = `${this.endpointRoot}/orgUser/`;
        const init = this.buildRequestInit('POST', entity);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Secondary Report Org User created successfully.`);
                return response.json();
            }

            const message = `Error creating Secondary Report Org User.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public deleteOrgUser(id: number): Promise<any> {

        const endpoint = `${this.endpointRoot}/orgUser/${id}`;
        const init = this.buildRequestInit('DELETE');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Secondary Report Org User deleted successfully.`);
                return response.json();
            }

            const message = `Error deleting Secondary Report Org User.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public toggleGlobal(id: number): Promise<any> {

        const endpoint = `${this.endpointRoot}/toggleGlobal/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addNotification(`Secondary Report toggled successfully.`);
                return response.json();
            }

            const message = `Error toggling Secondary Report.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public toggleState(id: number): Promise<any> {

        const endpoint = `${this.endpointRoot}/toggleState/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error toggling Secondary Report.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/SecondaryReportData.tsx